import { render, staticRenderFns } from "./FullContent.vue?vue&type=template&id=4130a763&scoped=true&"
var script = {}
import style0 from "./FullContent.vue?vue&type=style&index=0&id=4130a763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130a763",
  null
  
)

export default component.exports